import React, { useContext, useState } from 'react';
import forgeticon1 from '../../../Assets/Images/forgeticon1.png'
import { LangContext, FormNewPassword } from '../../../App'
import String from '../../../Assets/Localization/Local'
import { Modal, InputGroup, FormControl, Col, Row } from 'react-bootstrap'
import './ForgetPassword.css'
import { useForm } from "react-hook-form";
import { API_ENDPOINT } from '../../../AppConfig';
import axios from 'axios';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies'

const NewPassword = (props) => {

    const { lang } = useContext(LangContext)
    String.setLanguage(lang);
    const { openFormNewPass, ToggleForm_newPass } = useContext(FormNewPassword)

    const [show, setShow] = useState(true);
    const [Field1Type, setField1Type] = useState('password');
    const [Field2Type, setField2Type] = useState('password');
    const handleShow = () => setShow(true);
    const { register, handleSubmit, errors, control, watch, setValue, getValues } = useForm({
        // validationSchema: props.validation
    });
    const onSubmit = (data) => {
        console.log('data==> ', data, props)
        let uri = `${API_ENDPOINT}/phonePasswordChange`
        let submitData = {}
        submitData.phone = props.phone.phone
        submitData.password = data.password
        console.log('submit data=> ', submitData)
        axios.put(uri, submitData, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            console.log('send new pass done=> ', response.data)
            cookie.save("HBUser", response.data.user, { path: '/' })
            cookie.save("HB_token", response.data.token, { path: '/' })
            ToggleForm_newPass()
        }).catch(error => {
            console.log('send new pass error=> ', error.response)
        })
    }

    const handleField1Type = (e) => {
        console.log('eeee=> ', e.target.type)
        if (Field1Type === 'password') {
            setField1Type('text')
        }
        else {
            setField1Type('password')
        }
    }
    const handleField2Type = (e) => {
        console.log('eeee=> ', e.target.type)
        if (Field2Type === 'password') {
            setField2Type('text')
        }
        else {
            setField2Type('password')
        }
    }
    return (
        <div>
            <Modal className="forgetmodal text-center" show={show} onHide={props.close} animation={false}>
                <Modal.Header className="justify-content-center pb-0">
                    <h3 className="text-white mt-5">{String.forgetpassword}</h3>
                    <i style={{ left: lang === "ar" ? "10px" : "", right: lang === "en" ? "10px" : "" }} onClick={props.close} className="fa fa-close closeBTN"></i>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <div className="imgforgetcontainer">
                        <img src={forgeticon1} alt="deleteimg" className="forgetimg" />
                    </div>
                    <h5>{String.enterpassword}</h5>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '100%', position: 'relative' }}>
                        <Row>
                            <Col lg='12' style={{ marginBottom: '40px' }}>
                                <div style={{ marginBottom: '28px', position: 'relative' }}  >

                                    <input type={Field1Type} name="password" ref={register}
                                        placeholder={String.password}
                                        className="textStyleWithIcon px-4" style={{ direction: lang === "ar" ? 'rtl' : 'ltr' }} />
                                    <Link
                                        onClick={handleField1Type}
                                        className="TextFieldIconLink"
                                        style={{ right: lang === 'en' ? '1.5rem' : '', left: lang === 'ar' ? '1.5rem' : '', background: 'transparent', border: 'none', padding: '0px', outline: 'none' }}>
                                        <i className={Field1Type === 'password' ? 'fas fa-eye fa-2x' : 'fas fa-eye-slash fa-2x'}> </i>
                                    </Link>

                                </div>
                                <div className="textWithIcon"  >

                                    <input type={Field2Type} name="confirmPassword" ref={register}
                                        placeholder={String.confpassword}
                                        className="textStyleWithIcon px-4" style={{ direction: lang === "ar" ? 'rtl' : 'ltr' }} />
                                    <Link
                                        onClick={handleField2Type}
                                        className="TextFieldIconLink"
                                        style={{ right: lang === 'en' ? '1.5rem' : '', left: lang === 'ar' ? '1.5rem' : '', background: 'transparent', border: 'none', padding: '0px', outline: 'none' }}>
                                        <i className={Field2Type === 'password' ? 'fas fa-eye fa-2x' : 'fas fa-eye-slash fa-2x'}> </i>
                                    </Link>

                                </div>
                                {/* {errors[element.name] && <p className="ErrorStyle">{errors[element.name]["message"]}</p>} */}
                            </Col>
                        </Row>
                        <button className="btn nextBTN btn-block mb-4" type="submit"> {String.saveBTN} </button>
                    </form>
                    {/* <InputGroup className="mb-3">
                        {lang === "ar" ? <InputGroup.Prepend>
                            <InputGroup.Text style={{ borderRadius: " 25px 0 0 25px " }} id="basic-addon2"><i className="fas fa-eye fa-2x"></i></InputGroup.Text>
                        </InputGroup.Prepend> : ""
                        }
                        <FormControl style={{ textAlign: lang === "ar" ? "right" : "" }} placeholder={String.password} />
                        {lang === "en" ? <InputGroup.Prepend>
                            <InputGroup.Text style={{ borderRadius: "0 25px 25px 0" }} id="basic-addon2"><i className="fas fa-eye fa-2x"></i></InputGroup.Text>
                        </InputGroup.Prepend> : ""
                        }
                    </InputGroup>
                    <InputGroup className="mb-3">
                        {lang === "ar" ? <InputGroup.Prepend>
                            <InputGroup.Text style={{ borderRadius: " 25px 0 0 25px " }} id="basic-addon2"><i className="fas fa-eye fa-2x"></i></InputGroup.Text>
                        </InputGroup.Prepend> : ""
                        }
                        <FormControl style={{ textAlign: lang === "ar" ? "right" : "" }} placeholder={String.confpassword} />
                        {lang === "en" ? <InputGroup.Prepend>
                            <InputGroup.Text style={{ borderRadius: "0 25px 25px 0" }} id="basic-addon2"><i className="fas fa-eye fa-2x"></i></InputGroup.Text>
                        </InputGroup.Prepend> : ""
                        }
                    </InputGroup>
                    <button className="btn nextBTN btn-block mb-4" > {String.saveBTN} </button> */}
                </Modal.Body>
            </Modal>
        </div >
    );
}

export default NewPassword;

